import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBpoHGMHgJfEIRShQeDMOqfNxQAPLdebRM",
  authDomain: "strides-aar.firebaseapp.com",
  projectId: "strides-aar",
  storageBucket: "strides-aar.firebasestorage.app",
  messagingSenderId: "147480844128",
  appId: "1:147480844128:web:35a1994e828e6cc58e7005",
};


// Initialize Firebase

const app = initializeApp(firebaseConfig);


// Firebase Authentication

export const auth = getAuth(app);


// Cloud Firestore

export const db = getFirestore(app);


export default app;